import { useEffect, useState, useCallback } from "react";
import { api } from "../../lib/api";
import { CustomersTab } from "./CustomersTab";
import { EmployeesTab } from "./EmployeesTab";

export function PeopleModule() {
  const [inner, setInner] = useState("customers");
  const [customers, setCustomers] = useState([]);
  const [employees, setEmployees] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const [c, e] = await Promise.all([api.get("/customers"), api.get("/employees")]);
      setCustomers(c.data || []);
      setEmployees(e.data || []);
    } catch (e) { console.warn("People module: failed to load customers/employees", e); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <div className="space-y-6" data-testid="people-module">
      <div className="flex gap-2">
        <button
          onClick={() => setInner("customers")}
          data-testid="people-tab-customers"
          className={`px-6 py-3 text-sm font-bold tracking-[0.14em] uppercase border-b-4 transition-colors ${inner === "customers" ? "bg-white border-[#2F5F80] text-[#23282B]" : "bg-transparent border-transparent text-[#23282B]/50 hover:text-[#23282B]"}`}
        >
          Customers <span className="ml-1 font-mono-av text-xs opacity-60">{customers.length}</span>
        </button>
        <button
          onClick={() => setInner("employees")}
          data-testid="people-tab-employees"
          className={`px-6 py-3 text-sm font-bold tracking-[0.14em] uppercase border-b-4 transition-colors ${inner === "employees" ? "bg-white border-[#2F5F80] text-[#23282B]" : "bg-transparent border-transparent text-[#23282B]/50 hover:text-[#23282B]"}`}
        >
          Employees <span className="ml-1 font-mono-av text-xs opacity-60">{employees.length}</span>
        </button>
      </div>

      {inner === "customers" ? (
        <CustomersTab customers={customers} onRefresh={refresh} />
      ) : (
        <EmployeesTab employees={employees} onRefresh={refresh} />
      )}
    </div>
  );
}
